"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * @module filterObject
 *
 * @description
 *
 * Create an object composed of the properties of object that are not omitted.
 *
 * @example
 *
 * import filterObject from 'dumb-bem/lib/filter-object'
 *
 * filterObject({ a: 1, b: 2, c: 3}, ['a', 'b'])
 *   // => { c: 3 }
 *
 */
exports.default = function (obj) {
  var keysToRemove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var target = {};

  for (var i in obj) {
    if (keysToRemove.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;

    target[i] = obj[i];
  }

  return target;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/dumb-bem/lib/filter-object.js
// module id = 1173
// module chunks = 0